module.exports = __webpack_public_path__ + "media/images/linkedin-white-e70578e7.png";